// export function ShimmerImage({width, height}: any) {
//   const shimmerStyle = {
//     width: typeof width === 'number' ? `${width}px` : width,
//     height: typeof height === 'number' ? `${height}px` : height,
//   }

//   return <div className='rounded loader-shimmer-image shimmer-animation' style={shimmerStyle}></div>
// }
import React from 'react'

export function ShimmerImage({
  width,
  height,
  children,
}: {
  width: any
  height: any
  children?: React.ReactNode
}) {
  const shimmerStyle: any = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
    position: 'relative'
  }

  return (
    <div className='rounded loader-shimmer-image shimmer-animation' style={shimmerStyle}>
      {children && <div className='shimmer-children-container'>{children}</div>}
    </div>
  )
}
